import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateLoader, TranslateModuleConfig, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageEnum } from '../../core/common/enum';
import { lastValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Constants } from 'src/app/core/common';
import { APP_BASE_HREF } from '@angular/common';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, 'assets/locales/', '.json');
}

export function ApplicationInitializerFactory(injector: Injector): () => Promise<void> {
  return () => ApplicationContainer(injector);
}

export const translationLoaderConfig: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
};

// application conatainer to return more than one function
async function ApplicationContainer(injector: Injector): Promise<void> {
  return initalizeTranslation(injector);
}

// initalize Translation and preload it
async function initalizeTranslation(injector: Injector): Promise<void> {
  await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
  const deaultLang = LanguageEnum.English;
  const translate: TranslateService = injector.get(TranslateService);
  translate.addLangs([LanguageEnum.English, LanguageEnum.Arabic]);
  const cookiesService = injector.get(CookieService);
  translate.setDefaultLang(
    cookiesService.get(Constants.APP_LANGUAGE_COOKIE_KEY)
      ? cookiesService.get(Constants.APP_LANGUAGE_COOKIE_KEY)
      : deaultLang
  );
  try {
    await lastValueFrom(
      translate.use(
        cookiesService.get(Constants.APP_LANGUAGE_COOKIE_KEY)
          ? cookiesService.get(Constants.APP_LANGUAGE_COOKIE_KEY)
          : deaultLang
      )
    );
  } catch (err) {}
}
